import { useEffect } from 'react';
import { trackingService } from './tracking-service';

/**
 * Guards against re-firing when the user moves between the terminal onboarding
 * screens (e.g. ApplicationPage redirecting to NoOfferAvailablePage) or
 * navigates back to one of them later in the same session.
 */
let hasTracked = false;

/**
 * Fires `onboarding_completed` once, when the user reaches a screen that marks
 * the end of onboarding.
 *
 * @param enabled - Pass `false` while the page is still loading or about to
 * redirect, so the event only fires once the screen is actually shown.
 */
export function useTrackOnboardingCompleted(enabled: boolean = true): void {
  useEffect(() => {
    if (!enabled || hasTracked) {
      return;
    }

    hasTracked = true;
    trackingService.trackEvent('onboarding_completed');
  }, [enabled]);
}
